import { ModelBase } from 'store/model-base';

export class NowXMUpgrade extends ModelBase {
    public static storeName: string = 'nowXMUpgrade';

    public xmUpgrade: NowtoXMUpgrade;

    public static create<T extends ModelBase>(initData: object): T {
        const upgradeData: NowXMUpgrade = super.create<NowXMUpgrade>(initData);
        
        return super.create<T>(upgradeData);    
    }

    public get isEligible(): boolean {
        return this.xmUpgrade.eligibility.toUpperCase() === 'ELIGIBLE';
    }
}

